var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import * as ReactFeather from "react-feather";
import IconContainer from "../IconContainer";
const FeatherIcons = (_a) => {
    var { className, name, size } = _a, props = __rest(_a, ["className", "name", "size"]);
    // eslint-disable-next-line import/namespace
    const Icon = ReactFeather[name];
    return (React.createElement(IconContainer, Object.assign({}, props, { className: classNames(`gerudo-icon-${name}`, size, className) }),
        React.createElement(Icon, null)));
};
export default FeatherIcons;
//# sourceMappingURL=FeatherIcons.js.map